import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mytc-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BadgeComponent {
  @Input({ required: true }) label: string;
}
